import React, { Component } from 'react'
import { Button, Form, Input, Select, message, Spin, Slider, InputNumber, Table, Tooltip } from 'antd'
import { Link } from 'dva/router'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import { all, create, get, update, remove } from '../../services/restApi'
import PropTypes from 'prop-types'
import moment from 'moment'
import config from '../../utils/config'
var Icon = require('react-fontawesome');
const _ = require('underscore')

const { Column } = Table;
const FormItem = Form.Item;
const Option = Select.Option;
const TextArea = Input.TextArea;
const ButtonGroup = Button.Group;

class IMSS extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            salary: {percent_employee: 0},
            factors: []
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        /*if (localStorage.getItem('hotelConta')) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('hotelConta'))};*/

        if (this.props.incomeType === 'cash_funds_trie' || this.props.incomeType === 'others_trie' || this.props.incomeType === 'payroll_trie')
            this.state = {...this.state, currentHotel: null};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        this.firstLoad();
    }


    /**
    * Consulta los registros
    */
    firstLoad () {
        this.props.dispatch({type: 'app/showLoadingTable'})

        all('IMSS', {limit: 1000}).then((resp) => {

            this.props.dispatch({type: 'app/hideLoadingTable'})

            var salary = _.find(resp.results, {name: 'salary'});
            resp.results = _.without(resp.results, salary);

            this.setState({ factors: resp.results, salary: salary });
        })        
    }


    /**
    * Envío del formulario
    */
    update (item) {

        // Model
        let data = {...item};
        data.percent_employee = this.props.form.getFieldValue(item.objectId + '_percent_employee');
        data.percent_company = this.props.form.getFieldValue(item.objectId + '_percent_company');

        data = _.omit(data, ['createdAt', 'updatedAt']);

        this.props.dispatch({type: 'app/showButtonLoading'})
        this.props.dispatch({type: 'app/showLoadingTable'})

        update('IMSS', data.objectId, data).then(resp => {

            this.props.dispatch({type: 'app/hideButtonLoading'})
            this.props.dispatch({type: 'app/hideLoadingTable'})

            message.success('Se ha actualizado el registro exitosamente');

        }).catch(e => {
            this.props.dispatch({type: 'app/hideButtonLoading'})
            this.props.dispatch({type: 'app/hideLoadingTable'})

            if (e && e.data) message.error(e.data.error);
            else message.error('Ha ocurrido un error. Intente más tarde')    
        });
    }


    /**
    * Render del componente
    */
    render () {
        return (
            <Form>
                <div className="row" style={{padding: '15px 0'}}>
                    <div className="col-md-3">
                        <FormItem label="Salario mínimo" hasFeedback>
                            {this.props.form.getFieldDecorator(this.state.salary.objectId + '_percent_employee', {
                                initialValue: this.state.salary.percent_employee,
                                rules: [{
                                    required: true,
                                    message: 'Por favor, ingrese el salario mínimo'
                                }]
                            })(
                                <InputNumber min={1} step={0.01} className="ant-input ant-input-lg" />
                            )}
                        </FormItem>
                    </div>

                    <div className="col-md-3" style={{marginTop: 40}}>
                        <Button type='primary' onClick={() => this.update(this.state.salary)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                            <Icon name="save" /> Guardar
                        </Button>
                    </div>
                </div>

                <div className="row">
                    <Spin spinning={this.props.app.loadingTable}>
                        <div className="col-md-12">
                            <Table 
                                dataSource={this.state.factors} 
                                rowKey="objectId" 
                                size="middle" 
                                pagination={false} >

                                <Column title="Prestaciones" key="years" render={(item) => (
                                    <span>{item.name}</span>
                                )}/>

                                <Column title="Empleado" key="percent_employee" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_percent_employee', {
                                            initialValue: item.percent_employee
                                        })(
                                            <InputNumber 
                                                min={0} 
                                                max={100} 
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Empresa" key="percent_company" render={(item) => (
                                    <FormItem style={{margin: 0}}>
                                        {this.props.form.getFieldDecorator(item.objectId + '_percent_company', {
                                            initialValue: item.percent_company
                                        })(
                                            <InputNumber 
                                                min={0} 
                                                max={100} 
                                                formatter={value => `${value}%`}
                                                parser={value => value.replace('%', '')} 
                                                className="ant-input ant-input-lg" />
                                        )}
                                    </FormItem>
                                )}/>

                                <Column title="Acciones" key="action" width={90}
                                    render={(item) => (
                                        <span className="actions">
                                            <ButtonGroup>
                                                <Tooltip placement="bottom" title="Actualizar">
                                                    <Button>
                                                        <Link onClick={() => { this.update(item) }}><Icon name="save" /></Link>
                                                    </Button>
                                                </Tooltip>
                                            </ButtonGroup>
                                        </span>
                                    )}
                                />
                            </Table>  
                        </div>
                    </Spin>
                </div>
            </Form>
        )
    }
}

IMSS.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({income, app}) => ({income, app}))(Form.create()(IMSS))


// WEBPACK FOOTER //
// ./src/components/config/imss.js